import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Instagram, Facebook, Phone, Mail, MapPin } from 'lucide-react';

const Footer8 = () => {
    const navigate = useNavigate();
    const [email, setEmail] = useState('');

    const handleSubscribe = (e) => {
        e.preventDefault();
        if (email.trim()) {
            setEmail('');
        }
    };

    const shopLinks = [
        { label: 'Anarkalis', path: '/template8/shop' },
        { label: 'Designer Sarees', path: '/template8/shop' },
        { label: 'Bridal Lehengas', path: '/template8/shop' },
        { label: 'Festive Wear', path: '/template8/shop' },
        { label: 'Everyday Grace', path: '/template8/shop' },
    ];

    const customerCareLinks = [
        { label: 'Contact Us', path: '/template8/contact' },
        { label: 'Shipping Policy', path: '/template8/shipping-policy' },
        { label: 'Returns & Exchange', path: '/template8/shipping-exchange' },
        { label: 'FAQs', path: '/template8/faqs' },
        { label: 'Track Order', path: '/template8/orders' },
    ];

    return (
        <>
            <style>{`
                @import url('https://fonts.googleapis.com/css2?family=Libre+Baskerville:wght@400;700&family=DM+Sans:wght@300;400;500;700&display=swap');
            `}</style>

            <footer style={{ backgroundColor: '#FDF2F8', borderTop: '1px solid #F9A8D4' }}>
                {/* Newsletter Section */}
                <div style={{ backgroundColor: '#BE185D' }}>
                    <div
                        style={{
                            maxWidth: '700px',
                            margin: '0 auto',
                            padding: '48px 24px',
                            textAlign: 'center',
                        }}
                    >
                        <h4
                            style={{
                                fontFamily: "'Libre Baskerville', serif",
                                fontSize: '24px',
                                fontWeight: 700,
                                color: '#FFFFFF',
                                margin: '0 0 8px 0',
                            }}
                        >
                            Join the Garden of Elegance
                        </h4>
                        <p
                            style={{
                                fontFamily: "'DM Sans', sans-serif",
                                fontSize: '14px',
                                color: 'rgba(255,255,255,0.8)',
                                margin: '0 0 24px 0',
                            }}
                        >
                            Subscribe for exclusive collections, style tips, and early access to new arrivals.
                        </p>
                        <form
                            onSubmit={handleSubscribe}
                            style={{
                                display: 'flex',
                                gap: '0',
                                maxWidth: '480px',
                                margin: '0 auto',
                            }}
                            className="mehak-newsletter-form"
                        >
                            <input
                                type="email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                placeholder="Enter your email"
                                required
                                style={{
                                    flex: 1,
                                    padding: '14px 20px',
                                    backgroundColor: '#FFFFFF',
                                    border: '2px solid transparent',
                                    borderRadius: '8px 0 0 8px',
                                    color: '#1A1A1A',
                                    fontFamily: "'DM Sans', sans-serif",
                                    fontSize: '14px',
                                    outline: 'none',
                                }}
                            />
                            <button
                                type="submit"
                                style={{
                                    padding: '14px 28px',
                                    backgroundColor: '#9D174D',
                                    color: '#FFFFFF',
                                    border: 'none',
                                    borderRadius: '0 8px 8px 0',
                                    fontFamily: "'DM Sans', sans-serif",
                                    fontSize: '13px',
                                    fontWeight: 600,
                                    letterSpacing: '1px',
                                    textTransform: 'uppercase',
                                    cursor: 'pointer',
                                    transition: 'background-color 0.3s ease',
                                }}
                                onMouseEnter={(e) => (e.target.style.backgroundColor = '#831843')}
                                onMouseLeave={(e) => (e.target.style.backgroundColor = '#9D174D')}
                            >
                                Subscribe
                            </button>
                        </form>
                    </div>
                </div>

                {/* Main Footer Content */}
                <div
                    style={{
                        maxWidth: '1400px',
                        margin: '0 auto',
                        padding: '64px 24px',
                    }}
                    className="mehak-footer-main"
                >
                    <div className="mehak-footer-grid">
                        {/* Column 1: Brand */}
                        <div>
                            <h3
                                style={{
                                    fontFamily: "'Libre Baskerville', serif",
                                    fontSize: '28px',
                                    fontWeight: 700,
                                    color: '#BE185D',
                                    margin: '0 0 12px 0',
                                }}
                            >
                                MEHAK
                            </h3>
                            <p
                                style={{
                                    fontFamily: "'DM Sans', sans-serif",
                                    fontSize: '14px',
                                    color: '#6B7280',
                                    lineHeight: 1.7,
                                    margin: '0 0 24px 0',
                                }}
                            >
                                Bloom Into Elegance. Handcrafted Indian fashion that celebrates the beauty of femininity with rose-kissed grace.
                            </p>
                            <div style={{ display: 'flex', gap: '12px' }}>
                                {[Instagram, Facebook].map((Icon, idx) => (
                                    <a
                                        key={idx}
                                        href="#"
                                        style={{
                                            width: '40px',
                                            height: '40px',
                                            borderRadius: '50%',
                                            border: '1px solid #F9A8D4',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            color: '#BE185D',
                                            transition: 'all 0.3s ease',
                                            textDecoration: 'none',
                                            backgroundColor: 'transparent',
                                        }}
                                        onMouseEnter={(e) => {
                                            e.currentTarget.style.backgroundColor = '#BE185D';
                                            e.currentTarget.style.color = '#FFFFFF';
                                            e.currentTarget.style.borderColor = '#BE185D';
                                        }}
                                        onMouseLeave={(e) => {
                                            e.currentTarget.style.backgroundColor = 'transparent';
                                            e.currentTarget.style.color = '#BE185D';
                                            e.currentTarget.style.borderColor = '#F9A8D4';
                                        }}
                                    >
                                        <Icon size={18} />
                                    </a>
                                ))}
                                <a
                                    href="#"
                                    style={{
                                        width: '40px',
                                        height: '40px',
                                        borderRadius: '50%',
                                        border: '1px solid #F9A8D4',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        color: '#BE185D',
                                        transition: 'all 0.3s ease',
                                        textDecoration: 'none',
                                        backgroundColor: 'transparent',
                                    }}
                                    onMouseEnter={(e) => {
                                        e.currentTarget.style.backgroundColor = '#BE185D';
                                        e.currentTarget.style.color = '#FFFFFF';
                                        e.currentTarget.style.borderColor = '#BE185D';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.currentTarget.style.backgroundColor = 'transparent';
                                        e.currentTarget.style.color = '#BE185D';
                                        e.currentTarget.style.borderColor = '#F9A8D4';
                                    }}
                                >
                                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                        <path d="M8 12a4 4 0 1 1 8 0c0 2.5-1.5 4.5-3 6l-1 3" />
                                        <path d="M12 2a10 10 0 1 0 4 19.2" />
                                    </svg>
                                </a>
                            </div>
                        </div>

                        {/* Column 2: Shop */}
                        <div>
                            <h4
                                style={{
                                    fontFamily: "'Libre Baskerville', serif",
                                    fontSize: '15px',
                                    fontWeight: 700,
                                    color: '#1A1A1A',
                                    margin: '0 0 20px 0',
                                }}
                            >
                                Shop
                            </h4>
                            <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                                {shopLinks.map((link) => (
                                    <li key={link.label} style={{ marginBottom: '12px' }}>
                                        <span
                                            onClick={() => navigate(link.path)}
                                            style={{
                                                fontFamily: "'DM Sans', sans-serif",
                                                fontSize: '14px',
                                                color: '#6B7280',
                                                cursor: 'pointer',
                                                transition: 'color 0.3s ease',
                                                textDecoration: 'none',
                                            }}
                                            onMouseEnter={(e) => (e.target.style.color = '#BE185D')}
                                            onMouseLeave={(e) => (e.target.style.color = '#6B7280')}
                                        >
                                            {link.label}
                                        </span>
                                    </li>
                                ))}
                            </ul>
                        </div>

                        {/* Column 3: Customer Care */}
                        <div>
                            <h4
                                style={{
                                    fontFamily: "'Libre Baskerville', serif",
                                    fontSize: '15px',
                                    fontWeight: 700,
                                    color: '#1A1A1A',
                                    margin: '0 0 20px 0',
                                }}
                            >
                                Customer Care
                            </h4>
                            <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                                {customerCareLinks.map((link) => (
                                    <li key={link.label} style={{ marginBottom: '12px' }}>
                                        <span
                                            onClick={() => navigate(link.path)}
                                            style={{
                                                fontFamily: "'DM Sans', sans-serif",
                                                fontSize: '14px',
                                                color: '#6B7280',
                                                cursor: 'pointer',
                                                transition: 'color 0.3s ease',
                                                textDecoration: 'none',
                                            }}
                                            onMouseEnter={(e) => (e.target.style.color = '#BE185D')}
                                            onMouseLeave={(e) => (e.target.style.color = '#6B7280')}
                                        >
                                            {link.label}
                                        </span>
                                    </li>
                                ))}
                            </ul>
                        </div>

                        {/* Column 4: Get In Touch */}
                        <div>
                            <h4
                                style={{
                                    fontFamily: "'Libre Baskerville', serif",
                                    fontSize: '15px',
                                    fontWeight: 700,
                                    color: '#1A1A1A',
                                    margin: '0 0 20px 0',
                                }}
                            >
                                Get In Touch
                            </h4>
                            <div style={{ display: 'flex', flexDirection: 'column', gap: '14px' }}>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                                    <Mail size={16} style={{ color: '#BE185D', flexShrink: 0 }} />
                                    <span style={{ fontFamily: "'DM Sans', sans-serif", fontSize: '14px', color: '#6B7280' }}>
                                        hello@mehak.com
                                    </span>
                                </div>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                                    <Phone size={16} style={{ color: '#BE185D', flexShrink: 0 }} />
                                    <span style={{ fontFamily: "'DM Sans', sans-serif", fontSize: '14px', color: '#6B7280' }}>
                                        +91 98765 43210
                                    </span>
                                </div>
                                <div style={{ display: 'flex', alignItems: 'flex-start', gap: '12px' }}>
                                    <MapPin size={16} style={{ color: '#BE185D', flexShrink: 0, marginTop: '2px' }} />
                                    <span style={{ fontFamily: "'DM Sans', sans-serif", fontSize: '14px', color: '#6B7280', lineHeight: 1.6 }}>
                                        Jaipur, Rajasthan, India
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Bottom Bar */}
                <div
                    style={{
                        borderTop: '1px solid #F9A8D4',
                        maxWidth: '1400px',
                        margin: '0 auto',
                        padding: '20px 24px',
                    }}
                >
                    <div
                        style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            flexWrap: 'wrap',
                            gap: '16px',
                        }}
                        className="mehak-footer-bottom"
                    >
                        <p style={{ fontFamily: "'DM Sans', sans-serif", fontSize: '12px', color: '#6B7280', margin: 0 }}>
                            &copy; 2026 MEHAK. All rights reserved.
                        </p>
                        <p style={{ fontFamily: "'DM Sans', sans-serif", fontSize: '12px', color: '#BE185D', margin: 0, fontStyle: 'italic' }}>
                            Crafted with love in India
                        </p>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                            <svg width="36" height="24" viewBox="0 0 36 24" fill="none">
                                <rect width="36" height="24" rx="4" fill="#FDF2F8" stroke="#F9A8D4" />
                                <text x="18" y="14" textAnchor="middle" fill="#BE185D" fontSize="8" fontWeight="bold" fontFamily="DM Sans, sans-serif">VISA</text>
                            </svg>
                            <svg width="36" height="24" viewBox="0 0 36 24" fill="none">
                                <rect width="36" height="24" rx="4" fill="#FDF2F8" stroke="#F9A8D4" />
                                <circle cx="15" cy="12" r="5" fill="#F9A8D4" opacity="0.6" />
                                <circle cx="21" cy="12" r="5" fill="#BE185D" opacity="0.4" />
                            </svg>
                            <svg width="36" height="24" viewBox="0 0 36 24" fill="none">
                                <rect width="36" height="24" rx="4" fill="#FDF2F8" stroke="#F9A8D4" />
                                <text x="18" y="14" textAnchor="middle" fill="#BE185D" fontSize="7" fontWeight="bold" fontFamily="DM Sans, sans-serif">UPI</text>
                            </svg>
                        </div>
                    </div>
                </div>

                {/* Responsive Styles */}
                <style>{`
                    .mehak-footer-grid {
                        display: grid;
                        grid-template-columns: repeat(4, 1fr);
                        gap: 48px;
                    }
                    @media (max-width: 768px) {
                        .mehak-footer-grid {
                            grid-template-columns: 1fr;
                            gap: 36px;
                        }
                        .mehak-footer-main {
                            padding: 40px 24px !important;
                        }
                        .mehak-footer-bottom {
                            flex-direction: column;
                            align-items: center !important;
                            text-align: center;
                        }
                        .mehak-newsletter-form {
                            flex-direction: column !important;
                        }
                        .mehak-newsletter-form input {
                            border-radius: 8px !important;
                            margin-bottom: 8px;
                        }
                        .mehak-newsletter-form button {
                            border-radius: 8px !important;
                        }
                    }
                    @media (min-width: 769px) and (max-width: 1024px) {
                        .mehak-footer-grid {
                            grid-template-columns: repeat(2, 1fr);
                        }
                    }
                `}</style>
            </footer>
        </>
    );
};

export default Footer8;
